import { useNavigate } from 'react-router-dom';
import useAuth from './UseAuth';
import { useEffect } from 'react';

const GuestGuard = ({ children }: any) => {
  const { isAuthenticated, role } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthenticated) {
      navigate(`/${role}`, { replace: true });
    }
  }, [isAuthenticated, navigate, role]);

  return children;
};

export default GuestGuard;
